import React, { useEffect, useRef, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { Box, Button, colors, Divider, Hidden, IconButton } from "@material-ui/core";
import { useStylesTF, useStylesLbl } from "../../../../../St/comps/UseStyle";
import ReceiptVoucherType from "../components/ReceiptVoucher-typeFilter";
import { useTranslation } from "react-i18next";
import { GetItemFromOptions } from "../../../../../services/global-services";
import { sto } from "../../../../../Context/InshData";
import RestInfoDialog from "../../../../Invs/BackEnd/models/RestInfo/RestInfoDialog";
import { CloudUpload, Search } from "@material-ui/icons";
import { menuBottonsFile } from "../../../../Invs/BackEnd/components/SearchItemsFunction";

export default function EExchangeVoucherForm(props) {
  const { changAutoCustomers, onChange, AutoOptions, object, formType,
    AutoOptionsB,
    branch,
    setBranch,
    branchT,
    optionsStocks,
    handleInputSearchCust,
    optionsCustomers,
    handleIconSearchCust,
    isMobileDevice,
    prmis,
    setFile,
    handleDownload,
  } = props;
  const clasTF = useStylesTF();
  const claslbl = useStylesLbl();
  const { t } = useTranslation(["forms"]);
  const onChangeAutoData = (propName, newValue) => {
    onChange(null, { name: "branch", value: newValue.id });
    setBranch(newValue);
  };
  const [infoData, setInfoData] = useState({ open: false });

  const valuebranch = GetItemFromOptions(formType === "edit" && !props.isDialogData ? branchT : props.isDialogData ? props.invData.branch : branch.id === -1 ?? sto.branchi, AutoOptionsB.Branches ?? []);
  const getoptionCustomers = (option) => {
    return `${option?.name + '  ' + option?.acc_no ?? ""}`
  };

  
  const [menPostion, setMenuPostion] = useState(null);
  const openFileDialog = () => {
    fileInputRef.current.click();
  };
  const fileInputRef = useRef(null);
  const handleFileSelect = (event) => {
    const selected = event.target.files[0];
    setFile(selected);
  };
  const handleClickOutLine = () => {
    setMenuPostion(null);
  };
  const handleClickInLine = (e) => {
    e.preventDefault();
    setMenuPostion({
      x: e.pageX,
      y: e.pageY,
    });
  };

  return (
    <React.Fragment>
      <Grid container  style={{padding:isMobileDevice?5:10}} spacing={isMobileDevice? 1:2}>
        <Grid item lg={3} md={4} sm={4} xs={12}>
          <Autocomplete
            value={branch.id == -1 ? valuebranch : branch}
            onChange={(event, newValue) => {
              onChangeAutoData("branch", newValue);
            }}
            id="controllable-states-demo"
            size="small"
            options={AutoOptionsB.Branches}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            disableClearable
            disabled={formType == "edit" ? true : props.isDialogData == true ? true : sto.User_typei == 1 ? false : true}
            renderInput={(params) => (
              <TextField
                id="valueCostcenter"
                {...params}
                label={t("branch")}
                variant="outlined"
                size="small"
                InputLabelProps={{ className: claslbl.clor }}
              />
            )}
          />
        </Grid>
        <Grid item lg={3} md={4} sm={4} xs={6}>
          <TextField
            type="text"
            fullWidth
            variant="outlined"
            size="small"
            id="id"
            label={t("voucher-id")}
            className={clasTF.rootEDS}
            InputProps={{ className: clasTF.input, readOnly: true }}
            name="id"
            value={object.id}
          />
        </Grid>
        <Grid item lg={3} md={4} sm={4} xs={6}>
          <TextField
            type="number"
            fullWidth
            variant="outlined"
            size="small"
            id="ref_no"
            label={t("ref-no")}
            className={clasTF.rootEDS}
            InputProps={{ className: clasTF.input }}
            name="ref_no"
            value={object.ref_no}
            onChange={(e) =>
              onChange(null, { name: "ref_no", value: e.target.value })
            }
          />
        </Grid>

        <Grid item lg={3} md={4} sm={6} xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            id="date"
            label={t("date")}
            className={clasTF.rootEDS}
            type="date"
            format="YYYY-MM-DD"
            InputLabelProps={{ shrink: true }}
            name="date"
            value={object.date}
            onChange={(e) =>
              onChange(null, { name: "date", value: e.target.value })
            }
          />
        </Grid>

        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Divider />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Autocomplete
            value={object.customer}
            onInputChange={(event, newValue, reason) => {
              if (reason === "input") handleInputSearchCust(event, newValue, reason);
            }}
            options={optionsCustomers}
            id="controllable-states-demo"
            size="small"
            getOptionLabel={(option) =>
              getoptionCustomers(option)
            }
            style={{ backgroundColor: colors.orange[50] }}
            disableClearable
            renderInput={(params) => (
              <Box size="small" display={"flex"} textAlign={"center"}>
              <TextField
                id="valueCustomers"
                {...params}
                label={t("payment-to-account")}
                // variant="outlined"
                size="small"
                fullWidth
                textAlign={"center"}
                InputLabelProps={{ className: claslbl.clor }}
              />
               <IconButton size="small" onClick={handleIconSearchCust}>
                  <Search/>
                </IconButton>
              </Box>
            )}
            onChange={(event, newValue) => {
              changAutoCustomers(newValue);
            }}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <TextField
            type="number"
            fullWidth
            variant="outlined"
            size="small"
            id="val"
            label={t("amount")}
            className={clasTF.rootEDS}
            style={{ backgroundColor: colors.grey[50] }}
            InputProps={{ className: clasTF.input }}
            name="val"
            value={object.val}
            onChange={(e) =>
              onChange(null, { name: "val", value: e.target.value })
            }
          />
        </Grid>

        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Divider />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Autocomplete
            value={object.user}
            onChange={(event, newValue) => {
              onChange(null, { name: "user", value: newValue });
            }}
            id="controllable-states-demo"
            size="small"
            options={AutoOptions.Users}
            disabled={sto.User_typei == 1 ? false : true}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            disableClearable
            renderInput={(params) => (
              <TextField
                id="valueUsers"
                {...params}
                label={t("user")}
                variant="outlined"
                size="small"
                InputLabelProps={{ className: claslbl.clor }}
              />
            )}
          />
        </Grid>

        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Autocomplete
            value={object.center}
            onChange={(event, newValue) => {
              onChange(null, { name: "center", value: newValue });
            }}
            id="controllable-states-demo"
            size="small"
            options={AutoOptions.costcenters}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            disableClearable
            renderInput={(params) => (
              <TextField
                id="valueCostcenter"
                {...params}
                label={t("center")}
                variant="outlined"
                size="small"
                InputLabelProps={{ className: claslbl.clor }}
              />
            )}
          />
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <ReceiptVoucherType
            {...{
              type: object.type,
              onChange,
            }}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          {object.type == "1" ? (
            <Autocomplete
              value={object.stock}
              onChange={(event, newValue) => {
                onChange(null, { name: "stock", value: newValue });
              }}
              id="controllable-states-demoew"
              size="small"
              options={optionsStocks}
              style={{ backgroundColor: colors.grey[50] }}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.name
              }
              disableClearable
              renderInput={(params) => (
                <TextField
                  id="valueCostcenter"
                  {...params}
                  label={t("paid-from-account")}
                  variant="outlined"
                  size="small"
                  InputLabelProps={{ className: claslbl.clor }}
                />
              )}
            />
          ) : (
            <Autocomplete
              value={object.bank}
              onChange={(event, newValue) => {
                onChange(null, { name: "bank", value: newValue });
              }}
              id="controllable-states-demo67"
              size="small"
              options={AutoOptions.Banks}
              style={{ backgroundColor: colors.grey[50] }}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.name
              }
              // style={{  }}
              disableClearable
              renderInput={(params) => (
                <TextField
                  id="valueCostcenter"
                  {...params}
                  label={t("paid-from-account")}
                  variant="outlined"
                  size="small"
                  InputLabelProps={{ className: claslbl.clor }}
                />
              )}
            />
          )}
        </Grid>
        <Grid item lg={6} md={6} sm={12}></Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Autocomplete
            value={object.emp}
            onChange={(event, newValue) => {
              onChange(null, { name: "emp", value: newValue });
            }}
            id="controllable-states-demo4"
            size="small"
            options={AutoOptions.Users}
            disabled={sto.User_typei == 1 ? false : true}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            disableClearable
            renderInput={(params) => (
              <TextField
                id="valueSalesmen"
                {...params}
                label={t("delegate")}
                variant="outlined"
                size="small"
                InputLabelProps={{ className: claslbl.clor }}
              />
            )}
          />
        </Grid>

        <Grid item lg={formType == "edit" ? 10 : 11} md={formType == "edit" ? 10 : 11} sm={12} xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            id="notes"
            label={t("note")}
            className={clasTF.rootEDS}
            InputProps={{ className: clasTF.input }}
            name="notes"
            value={object.notes}
            onChange={(e) =>
              onChange(null, { name: "notes", value: e.target.value })
            }
          />
        </Grid>
        {prmis?.ARCHIVE === true && (
          <Grid item lg={1} md={1} sm={2} xs={2} >
            {formType !== "edit" ?
              (
                <>
                  <Hidden smDown>
                    <Button
                      fullWidth
                      autoFocus
                      variant="contained"
                      onClick={(e) => {
                        openFileDialog();
                      }}
                      style={{
                        background: colors.grey[300],
                        ...{
                          paddingLeft: 0,
                          paddingRight: 0,
                        },
                      }}
                      startIcon={<CloudUpload />}
                    >
                      {"  "}
                    </Button>
                  </Hidden>
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileSelect} />
                </>
              ) : (
                <>
                  <Hidden smDown>

                    <Button
                      fullWidth
                      autoFocus
                      variant="contained"
                      color="#000"
                      onClick={(e) => {
                        handleClickInLine(e);
                      }}
                      style={{
                        background: colors.grey[300],
                        ...{
                          paddingLeft: 0,
                          paddingRight: 0,
                        },
                      }}
                      startIcon={<CloudUpload />}
                    >
                      {"  "}
                    </Button>
                  </Hidden>

                </>
              )}


          </Grid>
        )}
        {menPostion && menuBottonsFile(handleClickOutLine, openFileDialog, handleDownload, menPostion, fileInputRef, handleFileSelect)}
       
        {formType == "edit" && (
          <Grid item lg={1} md={1} sm={4} xs={12} >
            <Hidden only={["xs"]}>
              <Button
                fullWidth
                autoFocus
                variant="contained"
                color="#000"
                onClick={(e) => {
                  setInfoData({ open: true, })
                }}
                style={{
                  background: colors.grey[300],
                  ...{
                    paddingLeft: 0,
                    paddingRight: 0,
                  },
                }}
              >
                {t("restriction") + "  "}
              </Button>
            </Hidden>
          </Grid>
        )}

        {formType == "edit" && (
          <RestInfoDialog
            infoData={infoData}
            setInfoData={setInfoData}
            res_id={object.rest_id}
            branch={object.branch}
            fromInv={0}
            proc_id={0}
          />
        )}
      </Grid>
    </React.Fragment>
  );
}
